import _ from 'lodash'
import { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios'
import { i18n } from 'i18next'
import { call, cancelled, getContext, select } from 'redux-saga/effects'

import { getLocaleMap } from '../redux/config/selectors'
import { LocaleMap } from '../redux/config/types'

// istanbul ignore next
export const makeApiCall = (axios: AxiosInstance, config: AxiosRequestConfig) => axios(config)

export function createRequestParams(
  config: AxiosRequestConfig,
  localeMap: LocaleMap,
  { umbracoCall, cancelToken }: { umbracoCall?: boolean; cancelToken?: CancelToken } = {}
) {
  const reqData: AxiosRequestConfig = {
    ...config,
    headers: {
      ...config.headers,
      'Accept-Language': umbracoCall ? localeMap.umbraco : localeMap.api
    },
    cancelToken
  }

  return reqData
}

export function appendToFormData(obj: any, formData: FormData): FormData {
  const createFormData = (obj: any, subKeyStr = '') => {
    for (const i in obj) {
      const value = obj[i]
      const subKeyStrTrans = subKeyStr ? subKeyStr + '[' + i + ']' : i

      if (_.isString(value) || _.isNumber(value)) {
        formData.append(subKeyStrTrans, _.toString(value))
      } else if (_.isObject(value)) {
        createFormData(value, subKeyStrTrans)
      }
    }
  }
  createFormData(obj)

  return formData
}

export function* apiCall<Response>({
  umbracoCall,
  overrideLang,
  ...axiosConfig
}: AxiosRequestConfig & { umbracoCall?: boolean; overrideLang?: string }): Generator<
  any,
  AxiosResponse<Response>,
  any
> {
  const axios = yield getContext('axios')
  const source = axios.CancelToken.source()
  try {
    const i18n: i18n = yield getContext('i18n')

    const localeMap: LocaleMap = yield select(getLocaleMap, overrideLang || i18n.language)

    const reqData = createRequestParams(axiosConfig, localeMap, {
      umbracoCall,
      cancelToken: source.token
    })

    const res = yield call(makeApiCall, axios, reqData)
    return res
  } finally {
    if (yield cancelled()) {
      source.cancel('cancelled')
    }
  }
}
